module.exports = __webpack_public_path__ + "img/pin_exchange_blue.9fb8a7bf.svg";